import { render, staticRenderFns } from "./ZipDownload.vue?vue&type=template&id=24729b09&scoped=true"
import script from "./ZipDownload.vue?vue&type=script&lang=js"
export * from "./ZipDownload.vue?vue&type=script&lang=js"
import style0 from "./ZipDownload.vue?vue&type=style&index=0&id=24729b09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24729b09",
  null
  
)

export default component.exports